import { IProductPriceHistory } from 'interfaces/IProductPriceHistory';
import { useCallback, useMemo } from 'react';
import { useFetch } from './useFetch';

export interface IResponseProductPriceHistory {
  // ProductPricesHistory: IProductPriceHistory[];
  ProductPriceHistories: IProductPriceHistory[];
}

export const useProductPriceHistoryService = () => {
  const { callApi } = useFetch();

  const findProductPriceHistoryByCompanyId = useCallback(
    async (id: number, currencyId: number) => {
      const result = await callApi<IResponseProductPriceHistory>({
        url: `ProductPriceHistory/FindProductPriceHistoryByCompanyId?CompanyId=${id}&CurrencyId=${currencyId}`,
        method: 'get',
        prefixMsgError:
          'error in useProductPriceHistoryService - findProductPriceHistoryByCompanyId:'
      });
      return result;
    },
    [callApi]
  );

  const findProductPriceHistoryByClientId = useCallback(
    async (id: number, currencyId: number) => {
      const result = await callApi<IResponseProductPriceHistory>({
        url: `ProductPriceHistory/FindProductPriceHistoryByClientId?ClientId=${id}&CurrencyId=${currencyId}`,
        method: 'get',
        prefixMsgError:
          'error in useProductPriceService - findProductPriceHistoryByClientId:'
      });
      return result;
    },
    [callApi]
  );

  return useMemo(
    () => ({
      productPriceHistoryService: {
        findProductPriceHistoryByCompanyId,
        findProductPriceHistoryByClientId
      }
    }),
    [findProductPriceHistoryByCompanyId, findProductPriceHistoryByClientId]
  );
};
